export default {
    namespaced: true,

    state: () => {
        return {
            loading: false,
            departments: [],
        }
    },

    getters: {
        loading(state) {
            return state.loading;
        },

        departments(state) {
            return state.departments.map((item, sl) => {
                item.sl = sl + 1;
                return item;
            });
        }
    },

    mutations: {
        setLoading(state, loading) {
            state.loading = loading
        },

        setDepartment(state, departments) {
            state.departments = departments
        },
    },

    actions: {
        async getDepartments(context) {
            context.commit('setLoading', true);
        
            await axios.get(`${this.state.host}/get-departments`, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                context.commit('setDepartment', res.data.departments);
            })
            .catch(error => this.dispatch('snackbar/error', error))

            context.commit('setLoading', false);
        },

        async saveDepartment(context, payload) {
            let isSuccess = false;

            let url = '';
            if(payload.id != null) {
                url = 'update-department';
            } else {
                url = 'add-department';
                delete payload.id
            }

            await axios.post(`${this.state.host}/${url}`, payload, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getDepartments');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        },

        async deleteDepartment(context, id) {
            let isSuccess = false;

            await axios.delete(`${this.state.host}/delete-department/${id}`, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getDepartments');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        }
    }
}
